import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import VideoCard from "./VideoCard";
import VideoCardCurrentMonth from "./VideoCardCurrentMonth";
import { withRouter } from "react-router-dom";
import videoItemList from "./catalog_list";

class VideoPage extends Component {
  state = { video: null, currentMonthVideo: null, videoType: null };

  // componentDidUpdate (prevProps, prevState) {
  //     return !this.state.video ? this.getVideo() : null;
  // }

  componentDidMount() {
    this.getVideo();
  }

  componentWillMount() { }

  getVideo() {
    const currentVideoId = this.props.match.params.tag;
    const currentType = this.props.match.params.trainingType || null;
    if (!currentType || !currentVideoId) {
      this.props.history.push("/app/training/security");
    }

    const currentVideo = videoItemList[currentType].filter(obj => {
      return String(obj.id) === String(currentVideoId);
    })[0];
    
    const currentMonthVideo = videoItemList['currentMonthsVideo'][0];
    this.setState({ video: currentVideo, currentMonthVideo: currentMonthVideo, videoType: currentType });

  }

  render() {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Training</h3>
            <h3 className="page-subhead subhead">
              Interactive videos to help your team with security and HIPAA
              awareness.
            </h3>
          </Col>
        </Row>
        <Row>
          {
            (
              this.state.currentMonthVideo && (
                (this.state.video === undefined || this.state.video === null) ? (
                  <VideoCardCurrentMonth currentVideo={this.state.currentMonthVideo} />
                ) : (
                    <VideoCard currentVideo={this.state.video} currentType={this.state.videoType}/>
                  )
              )
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(VideoPage);



// WEBPACK FOOTER //
// ./src/components/training/components/VideoPage.js